import { Box, Typography } from "@mui/material";
import type { DrillDown } from "../types/timeEfficiency.types";
import { TE_COLORS } from "./theme";

const LABELS: Record<DrillDown["type"], (etapa?: string) => string> = {
  reabertura: () => "Filtrando por projetos com reabertura em todos os painéis",
  etapaParada: (etapa) =>
    `Filtrando por projetos parados em "${etapa}" agora, em todos os painéis`,
  etapaLenta: (etapa) =>
    `Filtrando por concluídos que passaram por "${etapa}", em todos os painéis`,
  acimaMedia: () =>
    "Filtrando por finalizados com tempo total acima da média, em todos os painéis",
};

interface FilterChipProps {
  drillDown: DrillDown | null;
  onClear: () => void;
}

export function FilterChip({ drillDown, onClear }: FilterChipProps) {
  if (!drillDown) return null;
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        bgcolor: TE_COLORS.amberBg,
        color: TE_COLORS.amberFg,
        border: "1px solid #F2DF9A",
        borderRadius: "20px",
        px: 1.5,
        py: 0.75,
        fontSize: 12,
        fontWeight: 600,
        my: 1.25,
      }}
    >
      {LABELS[drillDown.type](drillDown.etapa)}
      <Typography
        component="button"
        onClick={onClear}
        sx={{
          all: "unset",
          cursor: "pointer",
          color: TE_COLORS.amberFg,
          fontSize: 14,
          lineHeight: 1,
          fontWeight: 700,
        }}
      >
        ×
      </Typography>
    </Box>
  );
}
